import * as React from 'react';
const CustomDnbSpare = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={40} height={40} fill="none" {...props}>
    <path
      stroke="#A5E1D2"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M20 6a2 2 0 1 1 4 0m-6 8h7M8.983 12.35c-.342-.747.025-1.634.79-1.903a6.1 6.1 0 0 1 2.017-.353c.977 0 1.905.233 2.715.643C16.573 9.637 19.41 9 22.045 9 29.412 9 35 14.109 35 20.25c0 2.594-1.066 4.86-2.852 6.742a1.4 1.4 0 0 0-.291.459l-1.721 5.66a1.36 1.36 0 0 1-1.272.889H25.66a1.37 1.37 0 0 1-1.338-1.122l-.232-1.755A1.37 1.37 0 0 0 22.753 30h-2.347c-.651 0-1.213.471-1.338 1.123l-.157 1.755A1.37 1.37 0 0 1 17.573 34h-3.091c-.595 0-1.12-.393-1.3-.97l-1.17-4.379a1.37 1.37 0 0 0-.876-.901C9.442 27.192 5 25.031 5 22.48v-2.53c0-1.66 1.268-3.03 2.911-3.245a1.3 1.3 0 0 0 .819-.471l.746-.9a1.41 1.41 0 0 0 .194-1.483z"
    />
  </svg>
);
export default CustomDnbSpare;
